import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import WarningLoaderCircle from '@perpay-web/components/base/WarningLoaderCircle/WarningLoaderCircle';
import {
    analyticsPinwheelModalEvent,
    analyticsPinwheelOpenPinwheelModal,
    pinwheelModalEvent,
} from '@perpay-web/fintech/actions/analytics/pinwheel';
import {
    updateDeductionAccountId,
    updateFailureDeduction,
    updateRetryingDeduction,
    updateSuccessDeduction,
} from '@perpay-web/fintech/actions/entities/deductions';
import PinwheelModal from '@perpay-web/fintech/components/composite/PinwheelModal/PinwheelModal';
import {
    PINWHEEL_LOGIN_EVENT,
    PINWHEEL_SUCCESS_EVENT,
} from '@perpay-web/fintech/constants/pinwheelConstants';
import {
    getDeductionToken,
    getDeductionUUID,
} from '@perpay-web/fintech/selectors/entities/deductions';
import { getFetchingPinwheelToken } from '@perpay-web/fintech/selectors/ui/cardOnboardingMVP2';
import { noop } from '@perpay-web/utils/noop';

const PinwheelModalContainer = ({
    onMount,
    onErrorExit,
    perpayModalContext,
    onSuccess = noop,
    onNonErrorExit = noop,
}) => {
    const dispatch = useDispatch();

    const isFetchingPinwheelToken = useSelector(getFetchingPinwheelToken);
    const deductionUUID = useSelector(getDeductionUUID);
    const linkToken = useSelector((state) =>
        getDeductionToken(state, deductionUUID),
    );

    const onEvent = useCallback(
        (eventName, eventPayload) => {
            dispatch(
                pinwheelModalEvent(eventName, eventPayload, perpayModalContext),
            );

            if (eventName === PINWHEEL_SUCCESS_EVENT) {
                dispatch(updateSuccessDeduction(eventPayload));
            } else if (eventName === PINWHEEL_LOGIN_EVENT) {
                dispatch(updateDeductionAccountId(eventPayload));
            }

            dispatch(
                analyticsPinwheelModalEvent({
                    eventName,
                    eventPayload,
                    perpayModalContext,
                }),
            );
        },
        [dispatch, perpayModalContext],
    );

    if (isFetchingPinwheelToken) return <WarningLoaderCircle />;

    return (
        <PinwheelModal
            onMount={() => {
                if (onMount) {
                    onMount();
                    return;
                }
                // This analytics action is dispatched for the payment setup flow,
                // but is not needed in other contexts.
                dispatch(analyticsPinwheelOpenPinwheelModal());
            }}
            onErrorExit={(error) => {
                onErrorExit(error);
                if (error.pendingRetry) {
                    dispatch(updateRetryingDeduction(error));
                } else {
                    dispatch(updateFailureDeduction(error));
                }
            }}
            onNonErrorExit={onNonErrorExit}
            onEvent={onEvent}
            onSuccess={onSuccess}
            linkToken={linkToken}
        />
    );
};

export default PinwheelModalContainer;
